import React from 'react';

// styles
import styles from "../Aboutus.module.css"

const AboutusTeam = ({ teamData }) => {
    return (
        <>
            <section className='w-100 position-relative d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-5 mt-4'>
                {teamData?.map((item) => (
                    <div key={item.id} className="d-flex flex-column align-items-center justify-content-center my-2 mx-md-2 mx-3">
                        <img className={styles.team_member_img} src={`https://backdev.azrmelk.com/images/TeamUserImages/${item.imageName}`} loading='lazy' alt="team_member_img" />

                        <div className='d-flex flex-column align-items-center justify-content-center mt-3'>
                            <div className={`mb-2 ${styles.member_title}`}>
                                {item.fullName}
                            </div>
                            <div className={styles.member_duty}>
                                {item.responsibility}
                            </div>
                        </div>
                    </div>
                ))}
            </section>
        </>
    );
};

export default AboutusTeam;